import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation MarkNotificationRead($notificationId: ID!) {
    markNotificationRead(notificationId: $notificationId) {
      id
    }
  }
`;

export const markNotificationRead = (id) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: {
      notificationId: id,
    },
  }).then(({ data }) => getSingleProp(data));
